import React, { Component } from 'react';

class MVentasModulesModal extends Component {

    render() {
        const { modules, editMode, userModules, CloseModulesModal, SaveModules, selectModule } = this.props;
        let arrayModules = []
        for (let index = 0; index < modules.length; index++) {
            const currModule = modules[index];
            const findUserModule = userModules.find((userModule) => currModule.idModule === userModule.idModule)
            let auxModule = {
                idModule: currModule.idModule,
                module: currModule.module,
                descr: currModule.descr,
            }
            if (findUserModule) {
                auxModule.active = findUserModule.active

            } else {
                auxModule.active = 'N'
            }
            arrayModules.push(auxModule)
        }

        return (
            <div className="modal fade bd-example-modal-lg modal-open scroll" id="mVentasModulesModal" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="modulesModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-open" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">Módulos</h4>
                            &nbsp;
                            <button type="button" className="close" onClick={CloseModulesModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" style={{ marginBottom: 0, minheight: 400, maxHeight: 500 }}>
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                <thead className="table-header">
                                                    <tr>
                                                        <td className="sticky-header table-header-yellow ">Título</td>
                                                        <td className="sticky-header table-header-yellow ">Activo</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!!arrayModules && arrayModules.map((module, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{module.descr}</td>
                                                                <td className="sticky-column">
                                                                    <input
                                                                        type="checkbox"
                                                                        disabled={!editMode ? true : false}
                                                                        checked={module.active == 'Y' ? true : false}
                                                                        style={{ minWidth: '100%', width: '15px', height: '15px' }}
                                                                        onChange={() => selectModule(module)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white"
                                onClick={CloseModulesModal}>
                                Cerrar
                            </button>
                            {editMode && (
                                <button type="button" className="btn botonCorrect"
                                    onClick={SaveModules}>
                                    Actualizar
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MVentasModulesModal;